module.exports = __webpack_public_path__ + "img/bullying-background-mobile.e8be0efa.png";